export default "__VITE_ASSET__b2975653__"